// extracted by mini-css-extract-plugin
module.exports = {"main":"home__main","heading":"home__heading"};